import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { appState } from '@/appState'
import { rootRoute } from '@/tenant/applications/application/root'

export const authenticationRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/authentication',
    component: lazyRouteComponent(() => import('./Authentication'), 'Authentication'),
    loader: async ({ parentMatchPromise, abortController }) => {
        await parentMatchPromise

        return client.applications.getApplicationAuthProviderOptions.query(
            { tenantId: appState.tenant!._id.toString() },
            { signal: abortController.signal }
        )
    },
})
